/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-16 17:00:29
 * @FilePath: /vise/packages/app-share/src/services/fetch-share-strategy/index.ts
 */
import { AjaxConfig } from '@tencent/wsl-ajax';
import { loadWslAjaxAsync } from '@/utils/load-wslib';
import { getReqHeader } from '@/utils/request';
import { TRPC_CALL_PATH, TRPC_CALL_TEST_PATH } from '@/constants/url';
import { checkIsTestEnvAndInBrowser } from '@/utils/env';
import { FetchShareStrategyReq, FetchShareStrategyRsp, FetchShareStrategyResult } from '@/types/services/fetch-share-strategy';

const getUrl = () => (checkIsTestEnvAndInBrowser() ? TRPC_CALL_TEST_PATH : TRPC_CALL_PATH);

/**
 *
 * 获取分享策略信息
 * @export
 * @param
 * @return {*}  {(Promise<FetchResult | null>)}
 */
export default async function fetchShareStrategy(params: FetchShareStrategyReq):
Promise<FetchShareStrategyResult | null> {
  const fetchConfig: AjaxConfig = {
    url: `${getUrl()}/GetShareStrategy`,
    withCredentials: true,
    method: 'POST',
    headers: { 'content-type': 'multipart/form-data' },
    responseType: 'json',
    data: JSON.stringify({
      req_body: params,
      req_header: getReqHeader(),
    }),
  };
  const wslAjax = await loadWslAjaxAsync();
  if (!wslAjax) return null;
  const { request } = wslAjax;
  const res = await request<FetchShareStrategyRsp>(fetchConfig);
  return res?.rsp_body;
}
